<header>
  <h4 class="title">{{ 'content_details.global_stats.title' | translate }}</h4>
  <kin-icon
    name="information"
    [color]="colorService.brandSecondary400()"
    [tooltip]="'content_details.global_stats.tooltip' | translate"
    tooltipPosition="top"
  />
</header>
<section>
  <app-content-global-stats-item
    icon="race_flag"
    [label]="'content_details.global_stats.sessions' | translate"
    [value]="content()?.sessions_total"
  />
  <app-content-global-stats-item
    icon="race_flag"
    [label]="'content_details.global_stats.finishers' | translate"
    [value]="content()?.finishers"
    [perfPercentage]="content()?.completion_percentage"
  />
  <app-content-global-stats-item
    icon="like_outline"
    [label]="'content_details.global_stats.likes' | translate"
    [value]="content()?.likes_total"
  />
  <app-content-global-stats-item
    icon="comment"
    [label]="'content_details.global_stats.comments' | translate"
    [value]="content()?.comments_total"
  />
</section>
